import QuestionValueRatio from "./QuestionValueRatio";

export default class QuestionValuePercentage extends QuestionValueRatio {
    constructor(numerator, denominator) {
        super(numerator, denominator);
    }

    toString() {
        //if (QuestionValuePercentage.isInt(this.value * 100)) {
        return Math.round(this.value * 100) + "%";
        // } else {
        //    return (this.value * 100).toFixed(2) + "%";
        // }
    }

    static isInt(n) {
        return n % 1 === 0;
    }
}